import {ChargeResponse} from '../models';

export const getChargeResponse = (response: any): ChargeResponse => {
  return {
    transactionId: response.id,
    success: response.success,
    errorMessage: response.message,
  };
};
